module.exports = __webpack_public_path__ + "img/large.1ca20234.svg";